import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AtendimentoRole } from '../types';

const ROLE_STORAGE_KEY = 'atendimento-role';

export const useRoleSelection = () => {
  const navigate = useNavigate();

  const clearRoleSelection = useCallback(() => {
    localStorage.removeItem(ROLE_STORAGE_KEY);
    navigate('/atendimentos');
  }, [navigate]);

  const setRoleSelection = useCallback((role: AtendimentoRole) => {
    localStorage.setItem(ROLE_STORAGE_KEY, role);
  }, []);

  const getRoleSelection = useCallback((): AtendimentoRole | null => {
    return localStorage.getItem(ROLE_STORAGE_KEY) as AtendimentoRole | null;
  }, []);

  const getRoleDisplayName = useCallback((role: AtendimentoRole): string => {
    const roleNames = {
      recepcionist: 'Recepção',
      doctor: 'Consultório',
      monitor: 'Monitor'
    };
    return roleNames[role];
  }, []);

  return {
    clearRoleSelection,
    setRoleSelection,
    getRoleSelection,
    getRoleDisplayName
  };
};
